/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import React from 'react'

import { EuiFlexItem, EuiSpacer, EuiText, EuiTitle } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import useOrganizationId from '@modules/billing-lib/hooks/useOrganizationId'

import useFilters from '../useFilters'
import CsvDownloadButton from '../CsvDownloadButton'

const CSVSection = () => {
  const { filters } = useFilters()
  const organizationId = useOrganizationId()

  return (
    <EuiFlexItem grow={false}>
      <EuiTitle size='xxs'>
        <h5>
          <FormattedMessage
            id='billing-usage.filters.csv-section.title'
            defaultMessage='Export data'
          />
        </h5>
      </EuiTitle>
      <EuiSpacer size='s' />
      <EuiText size='xs'>
        <FormattedMessage
          id='billing-usage.filters.csv-section.subtitle'
          defaultMessage='Download includes the selected group by and date range above'
        />
      </EuiText>
      <CsvDownloadButton
        startDate={filters.startDate}
        endDate={filters.endDate}
        organizationId={organizationId}
        instanceId={filters.instanceId}
        groupBy={filters.groupBy}
      />
    </EuiFlexItem>
  )
}

export default CSVSection
